import { motion } from "framer-motion";
import { GraduationCap } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const schools = [
  {
    degree: "M.S., Data Science & Engineering",
    school: "University of California, Los Angeles",
    dates: "Sep 2024 – Expected Aug 2027",
    note: "Online, while working full-time at BART.",
  },
  {
    degree: "B.S., Computer Science",
    school: "Loyola Marymount University",
    dates: "Aug 2020 – May 2024",
    note: "Bioinformatics research · Datathon 3rd place · Symposium presenter.",
  },
  {
    degree: "Data Science Program",
    school: "Massachusetts Institute of Technology",
    dates: "Jan 2024 – Apr 2024",
    note: "Online program mentored by industry leads, with hands-on projects in forecasting, computer vision, and classification tied to real industry problems.",
  },
];

export default function Education() {
  return (
    <section id="education" data-testid="education-section" className="py-28 md:py-40 border-t border-treeline">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="font-mono text-xs uppercase tracking-[0.35em] text-lime mb-6"
        >
          [ 04 ] · Education
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-cream mb-20"
        >
          The <span className="italic text-lime">foundation</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-treeline border border-treeline">
          {schools.map((s, i) => (
            <motion.div
              key={s.degree}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.1 * i, ease: EASE }}
              className="bg-forest p-10 md:p-14 group hover:bg-pine transition-colors duration-500"
              data-testid={`education-item-${i}`}
            >
              <GraduationCap size={22} className="text-lime mb-8" />
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-lime">{s.dates}</p>
              <h3 className="mt-4 font-display text-2xl sm:text-3xl text-cream">{s.degree}</h3>
              <p className="mt-2 font-mono text-sm text-sage">{s.school}</p>
              <p className="mt-6 font-mono text-xs leading-relaxed text-sage/80">{s.note}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
